import { useSnapshot } from 'valtio';

import { StudioModalName } from '@cartwhl/common/stores/navigationStore';
import Slider from '@cartwhl/ui/atoms/Slider';
import Timeline from '@cartwhl/ui/feature/Timeline';

import {
  animationPlayerStore,
  navigationStore,
  projectStore,
  sceneSettingsStore,
} from 'stores';

export default function TimelineComponent() {
  const { currentTime, currentFrame, duration, disabled } = useSnapshot(
    animationPlayerStore.state,
  );
  const { currentProject } = useSnapshot(projectStore.state);

  const {
    playbackSettings: { frameRate },
  } = useSnapshot(sceneSettingsStore.state);

  if (!currentProject.data) return null;

  const objectID = Object.keys(currentProject.data.characters)[0];

  if (!objectID) return null;

  return (
    <div className="flex h-full flex-col justify-between px-2 sm:px-0">
      <Timeline
        id={objectID}
        objectID={objectID}
        currentTime={currentTime}
        setCurrentTime={(time) => {
          animationPlayerStore.setFrame(time * frameRate);
        }}
        onEditClick={(id) => {
          navigationStore.setModal(StudioModalName.EDIT_MOTION, {
            jobID: id,
            objectID,
          });
        }}
      />
      <div className="relative bottom-[-8px] z-10 hidden md:block">
        <Slider
          min={0}
          max={duration.frames - 1}
          currentValue={currentFrame}
          onChange={(value) => {
            animationPlayerStore.setFrame(value);
          }}
          size="sm"
          trackColor="editor"
          rangeColor="blue"
          disabled={disabled}
        />
      </div>
    </div>
  );
}
